import { Suspense, lazy, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import PageLoader from "../components/Loader";
import Navbar from "../layout/Navbar";
import { appConfigAction } from "../store/actions/app";

const Dashboard = lazy(() => import("../pages/Dashboard"));
const Login = lazy(() => import("../pages/Login"));
const Categories = lazy(() => import("../pages/Dashboard/Categories"));

export const Router = () => {
  const location = useLocation();

  const scrollToTop = (url) => {
    if (!url.includes("#")) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    scrollToTop(window.location.href);
  }, [location]);

  const dispatch = useDispatch();
  const appLoading = useSelector((state) => state.app.loading);

  useEffect(() => {
    dispatch(appConfigAction());
  }, [dispatch]);

  if (appLoading) return <PageLoader />;

  return (
    <>
      {!location.pathname.includes("login") && <Navbar />}
      <Routes>
        <Route
          path="/login"
          element={
            <Suspense fallback={<PageLoader />}>
              <Login />
            </Suspense>
          }
        />

        <Route
          path="/*"
          element={
            <Suspense fallback={<PageLoader />}>
              <Dashboard />
            </Suspense>
          }
        />

 

        <Route path="404" element={<>Not Found</>} />
        <Route path="*" element={<Navigate to="/404" />} />
      </Routes>
    </>
  );
};

export default Router;
